import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getSurvey = (payload) =>
  httpClient.get(apis.getSurvey(payload), {
    ignore: true,
    ignoreLoading: true,
  });

export const makeSurveyNew = (payload) => httpClient.post(`${apis.makeSurveyNew()}`, payload);
export const makeEsgSurveyNew = (payload) => httpClient.post(`${apis.makeEsgSurveyNew()}`, payload);
export const checkSurveyHasposted = (payload) =>
  httpClient.get(`${apis.checkSurveyHasposted(payload)}`);
